import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-50 py-8 border-t border-gray-200" data-id="element-128">
      <div className="max-w-4xl mx-auto px-4" data-id="element-129">
        <div className="bg-gray-100 p-6 rounded-lg mb-6" data-id="element-130">
          <h3 className="text-lg font-bold text-gray-800 mb-3" data-id="element-131">
            RECHTLICHER HINWEIS:
          </h3>
          <p className="text-sm text-gray-700" data-id="element-132">
            Diese Informationen sind als Erfahrungsbericht und allgemeine
            Gesundheitsinformation gedacht. Sie ersetzen nicht die Beratung,
            Diagnose oder Behandlung durch einen qualifizierten Arzt. Eine
            Reduktion von Medikamenten sollte immer unter ärztlicher Aufsicht
            erfolgen. TianSole ist ein Wellness-Produkt zur Unterstützung des
            allgemeinen Wohlbefindens und nicht zur Behandlung oder Heilung von
            Krankheiten bestimmt.
          </p>
        </div>
        <div className="text-center text-sm text-gray-500" data-id="element-133">
          <p data-id="element-134">© 2025 TianSole. Alle Rechte vorbehalten.</p>
          <div className="mt-2 space-x-4" data-id="element-135">
            <a href="https://tiansole.de/pages/impressum" className="text-teal-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-136">
              Impressum
            </a>
            <a href="https://tiansole.de/pages/datenschutz" className="text-teal-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-137">
              Datenschutz
            </a>
            <a href="https://tiansole.de/pages/agb" className="text-teal-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-138">
              AGB
            </a>
            
          </div>
        </div>
      </div>
    </footer>;
}